export type PaymentParameters =
  | SignedPaymentParameters
  | LegacyPaymentParameters;

export interface PaymentParametersBase {
  id: string;
}

export interface SignedPaymentParameters extends PaymentParametersBase {
  signature: string;
}

export interface LegacyPaymentParameters extends PaymentParametersBase {
  customerGuid: string;
}

export function getPaymentParametersQuery(parameters: PaymentParameters) {
  const customerGuid =
    "customerGuid" in parameters ? parameters.customerGuid : null;
  const signature = "signature" in parameters ? parameters.signature : null;

  const query = new URLSearchParams();
  if (customerGuid) query.set("customer", customerGuid);
  if (signature) query.set("signature", signature);
  return query.toString();
}
